export default {
  custom_additive: {
    placeholder: 'Dodaj opcję niestandardową',
  },
  buttons: {
    add: 'Dodaj',
  },
};
